<template>
  <TransitionRoot appear :show="modelValue" as="template">
    <Dialog as="div" class="relative z-50" @close="setIsOpen(false)">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-shade-alpha-900" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center text-center"
          :class="fullscreen ? 'p-0' : 'p-4'"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="relative w-full bg-white p-6 text-left align-middle transition-all md:p-10"
              :class="
                fullscreen
                  ? ' min-h-screen w-screen max-w-none'
                  : `${widthClass} shadow-md`
              "
            >
              <DialogTitle
                v-if="$slots.title"
                as="h3"
                class="pr-10 text-mobile-xl font-semibold first-letter:uppercase md:text-xl"
              >
                <slot name="title"></slot>
              </DialogTitle>
              <button
                class="absolute top-6 right-6 md:top-10 md:right-10"
                @click="setIsOpen(false)"
              >
                <IconCross class="h-6 w-6" />
              </button>
              <DialogDescription
                as="div"
                class="flex flex-col gap-4"
                :class="$slots.title ? 'mt-4' : 'pr-10'"
              >
                <slot></slot>
              </DialogDescription>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script lang="ts" setup>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogDescription,
} from '@headlessui/vue'
import IconCross from '~/assets/icon/general/Cross.svg'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  fullscreen: {
    type: Boolean,
    default: false,
  },
  widthClass: {
    type: String,
    default: 'max-w-3xl',
  },
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

function setIsOpen(value) {
  emit('update:modelValue', value)
}
</script>
